import { TRANSPORTER_ADD, TRANSPORTER_EDIT, TRANSPORTER_VIEW, TRANSPORTER_IMPORT } from '../../utils/permissions'

export default [
  {
    path: '/transporters/list',
    name: 'transporters-list',
    component: () => import('@/views/transporters/TransporterList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Transporters List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Transporters' }, { title: 'Transporters List', active: true }],
      permissions: [TRANSPORTER_VIEW]
    }
  },

  {
    path: '/transporters/import',
    name: 'import-transporter-csv',
    component: () => import('@/views/transporters/Import.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Import Transporters CSV',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'transporters', url: '/transporters/list' },
        { title: 'Import Transporters CSV', active: true }
      ],
      permissions: [TRANSPORTER_IMPORT]
    }
  }
]
